import { render, staticRenderFns } from "./GraphDetail48.vue?vue&type=template&id=4cd81a50&scoped=true"
import script from "./GraphDetail48.vue?vue&type=script&lang=js"
export * from "./GraphDetail48.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd81a50",
  null
  
)

export default component.exports